import axios from 'axios';
import { globalStore } from '@/services/userService';
import Vue from 'vue'

let getToken = () => localStorage.getItem('token');
let locale = () => !!globalStore.getLanguage() ? globalStore.getLanguage() : Vue.i18n.locale();

const client = axios.create({
  baseURL: process.env.API_URL,
	headers: {
		'Content-Type' : 'application/json',
		'Accept' : 'application/json',
		'Content-Language': locale
	}
});

client.interceptors.response.use(
	function(response) {
		return response;
	}, function(error) {
		if (error.response.status == 401){
			window.location = "#/auth/login";
		}
		// else {
		// 	window.location = "#/error/error";
		// };
	}
);
	
client.interceptors.request.use(function (config) {
	if(getToken() != null) {
		config.headers.Authorization = `Bearer ${getToken()}`;
	}
	config.headers['Content-Language'] = locale()
	return config;
}, function (error) {
	return Promise.reject(error)
});

export default client; 



// WEBPACK FOOTER //
// ./src/services/http.js